<template>
  <el-dialog title="Lager" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Menge</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.id">
              <td v-text="product.name"></td>
              <td class="text-right" v-text="product.pivot.quantity"></td>
            </tr>
          </tbody>
        </table>
        <br>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'

export default {
  components: { [Dialog.name]: Dialog },
  props: ['show', 'products']
}
</script>

<style>
</style>
